// formatDateTime — DRY: "7 Sep 2026, 2:34 PM" style absolute timestamp,
// shared by the admin activity table, sessions list/detail, and the
// dashboard's upcoming-sessions card.
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  const datePart = date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  const timePart = date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  return `${datePart}, ${timePart}`;
}

// "10 Sep, 9:00 AM" — same style, no year. Used where the current year is
// implied (e.g. the tutor dashboard's upcoming-sessions/roster rows).
export function formatShortDateTime(iso: string): string {
  const date = new Date(iso);
  const datePart = date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  const timePart = date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  return `${datePart}, ${timePart}`;
}

// "Wednesday, 10 Sep 2026 at 9:00 AM" — full weekday + date + year, used by
// the student dashboard's Next session card where the exact day matters.
export function formatFullDateTime(iso: string): string {
  const date = new Date(iso);
  const datePart = date.toLocaleDateString("en-GB", {
    weekday: "long",
    day:     "numeric",
    month:   "short",
    year:    "numeric",
  });
  const timePart = date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  return `${datePart} at ${timePart}`;
}

// "1 Jul 2026" — date only, with year. Used by the student dashboard's
// Recent attendance card.
export function formatDate(iso: string): string {
  const date = new Date(iso);
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
